// src/utils/preguntar.js
// ============================================================================
// Modal de ENTRADA DE TEXTO global — reemplaza window.prompt() arcaico.
// ----------------------------------------------------------------------------
// Es async: devuelve Promise<string|null> (el texto ingresado, o null si se
// cancela/cierra). Se usa con await, igual de simple que window.prompt.
//
// Uso:
//   import preguntar from '../../utils/preguntar';
//   const motivo = await preguntar({
//     titulo: 'Anular pedido',
//     mensaje: 'Ingrese el motivo de anulación:',
//     textoConfirmar: 'Continuar',
//     // multilinea: true (default) → textarea;  false → input de una línea
//     // requerido: true (default) → no deja confirmar vacío
//     // placeholder, valorInicial opcionales
//   });
//   if (!motivo) return;   // canceló o vacío
//
// El host <PromptHost> (montado 1 vez en App.js) escucha y renderiza el modal.
// Si el host no está montado, cae a window.prompt como respaldo.
// ============================================================================

let host = null;

export function _registrarHostPrompt(fn) {
  host = fn;
  return () => { if (host === fn) host = null; };
}

export default function preguntar(opciones = {}) {
  return new Promise((resolve) => {
    if (!host) {
      // eslint-disable-next-line no-alert
      resolve(window.prompt(opciones.mensaje || opciones.titulo || ''));
      return;
    }
    host({ ...opciones, resolver: resolve });
  });
}
